<style scoped>
    @import "./index.css";
</style>

<template>
    <div id="layout-container-hui">
        <Button @click="add" icon="md-add" type="primary">添加养护</Button>
        <!--列表-->
        <DragableTable
                refs="table"
                :loading="loading"
                :columns-list="columns"
                v-model="data"
        ></DragableTable>
        <!--列表 end-->
        <!--右侧弹出窗口-->
        <Drawer :title="winTitle" :width="type == 1 ? 600 : 550" v-model="show">
            <!--养护记录列表-->
            <DragableTable v-if="type == 1"
                    refs="table"
                    :loading="loadingRecord"
                    :columns-list="columnsRecord"
                    v-model="dataRecord"
            ></DragableTable>
            <!--养护记录列表 end-->
            <!--添加养护-->
            <div v-if="type == 2">
                <Form ref="addMaintain" :model="addMaintain" :rules="addMaintainRule" :label-width="130">
                    <FormItem label="请选择养护模板" prop="fenlei">
                        <Select v-model="addMaintain.maintainId" style="width:100%">
                            <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem class="mb5">
                        <Button long size="large" :loading="addMaintain.btnLoading" type="primary" @click="handleSubmit('addMaintain')">
                            <span>{{!addMaintain.btnLoading ? '提交' : '提交中...'}}</span>
                        </Button>
                    </FormItem>
                </Form>
            </div>
            <!--添加养护记录-->
            <div v-if="type == 3">
                <Form ref="addRecord" :model="addRecord" :label-width="130">
                    <FormItem label="养护日期：" >
                        <i-col span="12"  prop="gmtMaintain">
                            <Date-picker type="date" v-model="addRecord.gmtMaintain" clearable placeholder="选择养护日期"  style="width: 200px"></Date-picker>
                        </i-col>
                    </FormItem>
                    <FormItem label="备注：">
                        <Input :maxlength="10" v-model="addRecord.remark"  placeholder="请输入备注"></Input>
                    </FormItem>
                    <FormItem class="mb5">
                        <Button long size="large" :loading="addRecord.btnLoading" type="primary" @click="addSubmit()">
                            <span>{{!addRecord.btnLoading ? '提交' : '提交中...'}}</span>
                        </Button>
                    </FormItem>
                </Form>
            </div>
        </Drawer>
    </div>
</template>

<script>
    import { DragableTable } from "@/views/Components/Table";
    export default {
        components: {
            DragableTable
        },
        data() {
            return {
                loading:true,
                columns: [
                    {
                        title: "养护类型",
                        align:'left',
                        key: "maintainType"
                    },
                    {
                        title: "养护周期(天)",
                        key: "timeInterval",
                        ellipsis:true
                    },
                    {
                        title: "上次养护时间",
                        key: "lastTime",

                    },
                    {
                        title: "状态",
                        key: "isExpire", //（1-养护过期 2-养护未过期）
                        render: (h, params) => {
                            if(params.row.isExpire){
                                var _val = '',_type = '';
                                switch(params.row.isExpire){
                                    case 1:
                                        _val  = '养护过期';
                                        _type = 'error';
                                        break;
                                    case 2:
                                        _val = '正常';
                                        _type = 'success';
                                        break;
                                }
                                return [
                                    h("Button", {
                                        props: {
                                            type: _type,
                                            size: 'small'
                                        }
                                    },_val)
                                ];
                            }else{
                                return h('span', '/');
                            }
                        }
                    },
                    {
                        title: "创建时间",
                        key: "addTime",
                        sortable: true
                    },
                    {
                        title: "操作",
                        align: "center",
                        render: (h, params) => {
                            return [
                                //添加
                                h("Button", {
                                    props: {
                                        icon: "md-add",
                                        type: "primary",
                                        size: 'small'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.addCon(params)
                                        }
                                    }
                                }),
                                //查看
                                h("Button", {
                                    props: {
                                        icon: "ios-search",
                                        type: "warning",
                                        size: 'small'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.showCon(params)
                                        }
                                    }
                                }),
                                //删除
                                h("Button", {
                                    props: {
                                        icon: "md-trash",
                                        type: "error",
                                        size: 'small'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.delCon(params)
                                        }
                                    }
                                })
                            ];
                        }
                    }
                ],
                data: [],

                //侧边弹出+步骤索引
                show:false,
                winTitle: "",
                type:'', //1记录 2添加

                //养护记录
                loadingRecord:true,
                columnsRecord: [
                    {
                        title: "养护类型",
                        align:'left',
                        key: "maintainType"
                    },
                    {
                        title: "养护时间",
                        key: "gmtMaintain",
                        ellipsis:true
                    },
                    {
                        title: "创建时间",
                        key: "gmtCreate",
                        sortable: true
                    },

                ],
                dataRecord: [],

                // -----添加---------
                list:[],
                // | 输入框数据
                addMaintain: {
                    maintainId: "",
                    btnLoading: false
                },
                // | 验证规则
                addMaintainRule: {
                    maintainId: [
                        {required: true, message: "请选择养护模板", trigger:"change"},
                    ],
                },
                // -----添加养护记录---------
                listRecord:[],
                // | 输入框数据
                custMaintainId: '',
                addRecord: {
                    gmtMaintain:'',
                    remark:'',
                    btnLoading: false
                },
            }
        },
        created() {
            this.getData();
        },
        methods: {
            //获取数据
            getData(){
                let that = this;
                this.loading = true;
                that.$func.ajax('listMaintain',{
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.data  = r.type;
                        that.loading = false;
                    }
                })
            },
            //添加
            add(){
                this.show = true;
                this.type = 2;
                this.winTitle = '添加保养';
                this.list=[];
                this.getMouldList();
            },
            //查看
            showCon(params) {
                let that = this;
                that.show = true;
                that.type = 1;
                that.winTitle = '查看养护记录';
                //获取详情
                that.$func.ajax('listRecord',{
                    custMaintainId :params.row.custMaintainId
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{

                        that.dataRecord  = r.type;
                        that.loadingRecord = false;
                    }
                })
            },
            //添加养护记录
            addCon(params) {
                let that = this;
                that.show = true;
                that.type = 3;
                that.winTitle = '添加养护记录';
                that.custMaintainId=params.row.custMaintainId;
            },
            //删除养护
            delCon(params) {
                let that = this;
                that.$Modal.confirm({
                    title: '确定删除养护吗？',
                    content: '删除养护后无法回撤，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('delMaintain', {
                            custMaintainId: params.row.custMaintainId
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.data.splice(params.index, 1);
                                that.$func.msg('删除成功');
                            }
                        })
                    }
                })
            },

            //获取设备分类
            getMouldList()
            {
                const that = this;
                that.$func.ajax('listMaintainMould',{
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        r.type.map(function(item,index){
                            that.list.push({
                                label : item.maintainType,
                                value : item.maintainId
                            });
                        })
                    }
                })
            },
            // +---------------
            // | 提交表单
            // +---------------
            handleSubmit(name) {
                const that = this;
                //验证表单
                that.$refs[name].validate(valid => {
                    if (valid)
                    {
                        that.$func.ajax('addMaintain',
                            {
                                maintainId:that[name].maintainId
                            },function(r){
                                if(!r.statusCode){
                                    that.$func.msg(r.message,'error');
                                }else{
                                    that.$func.msg('提交成功！');
                                    //按钮状态关闭
                                    that[name].btnLoading = false;
                                    that.show = false;
                                    that.getData();
                                }
                            })
                    }
                });
            },
            //添加养护记录
            addSubmit() {
                const that = this;
                console.log('123')
                if (that.addRecord.gmtMaintain)
                {
                    that.$func.ajax('addRecord',
                        {
                            custMaintainId:that.custMaintainId,
                            gmtMaintain:that.addRecord.gmtMaintain,
                            remark:that.addRecord.remark
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$func.msg('提交成功！');
                                //按钮状态关闭
                                that.addRecord.btnLoading = false;
                                that.show = false;
                                that.getData();
                            }
                        })
                }else{
                    that.$func.msg('养护日期必须填写','error');
                }
            },
        }
    };
</script>
